'use strict';

var App = require('app');
var AppState = require('app_state');
var CommonViews = require('components/common/views');
var Consts = require('consts');
var i18n = require('utils/i18n');
var DashboardView = require('components/dashboard/views/dashboard_view');
var HomeController = require('components/home/home_controller');
var Log = require('utils/log');

var DashboardController = {
    initializeDashboard: function () {
        var self = this;
        switch (App.pluginState) {
            case Consts.pluginStates.READY:
            case Consts.pluginStates.NOT_DEFINED:
                // nothing to do, continue
                break;
            case Consts.pluginStates.NOT_LOADED:
                // App was not initialized with user data
                var pluginRequest = App.loadPlugins();
                $.when(pluginRequest).done(function () {
                    self.initializeDashboard();
                });
                return;
            case Consts.pluginStates.BROKEN:
                Log.assert(false);
                console.log('plugin.js is broken');
                break;
        }
        App.navigate('dashboard');
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                if (!AppState.dashboardAvailable()) {
                    return;
                }
                AppState.layout.breadcrumbs.reset();
                App.trigger('sidebar:default', 'dashboard');

                if (!AppState.user.get('features').dashboard) {
                    // dashboard not enabled -> show empty page without fetching anything
                    App.showContentView(
                        new CommonViews.Message({ title: i18n.TR('Dashboard Feature nicht aktiviert.') })
                    );
                    return;
                }
                self.showDashboard();
            },
        });
    },

    showDashboard: function () {
        var self = this;
        this.getTileData({
            success: function (spec) {
                spec.controller = self;
                App.showContentView(new DashboardView(spec, self));
            },
            fail: function (response) {
                // request was successfull, but we still are in the fail-callback => json invalid
                if (response.status == 200) {
                    Log.assert(false);
                    console.log('dashboard.json is invalid');
                }
                var view = new CommonViews.Message({
                    title: i18n.TR('Hinweis'),
                    text: i18n.TR('Aktuell ist kein Dashboard konfiguriert.'),
                    color_class: 'box-color-info',
                });
                App.showContentView(view);
            },
        });
    },

    getTileData: function (options) {
        $.getJSON(
            '/api/v1/content/dashboard/dashboard.json',
            {
                'request-time': Date.now(),
            },
            function (spec) {
                var specString = JSON.stringify(spec);

                var lang = AppState.getUserLanguage();
                var lang_de_en = lang === 'de' ? 'de' : 'en';
                var lang_weather = ['de', 'en', 'es', 'fr', 'pl'].includes(lang) ? lang : 'en';

                specString = specString.replace('{{version}}', AppState.version);
                specString = specString.replace('{{lang}}', lang);
                specString = specString.replace('{{lang_de_en}}', lang_de_en);
                specString = specString.replace('{{lang_weather}}', lang_weather);

                spec = JSON.parse(specString);

                _.each(spec.tiles, function (t) {
                    Log.assert(typeof t.source === 'string');

                    t.width = t.width || 4;
                    t.height = t.height || 2;
                });
                options.success(spec);
            }
        ).fail(options.fail);
    },
};

module.exports = DashboardController;
